export enum Status {
    ON_TIME_NOT_DELIVERED = 'Not Delivered - On-Time',
    ON_TIME_RE_DELIVERED = 'Re-Delivered - On-Time',
    ON_TIME_DELIVERED = 'Delivered - On-Time',
    LATE_NOT_DELIVERED = 'Not Delivered - Late',
    LATE_RE_DELIVERED = 'Re-Delivered - Late',
    LATE_DELIVERED = 'Delivered - Late',
    BACKFILL_PENDING = 'Backfill Pending'
}
